import { useEffect } from "react";

import { RemoteParticipant } from "twilio-video";

import { DataTrackMessage } from "../../../../constants";
import useVideoContext from "../useVideoContext/useVideoContext";

export default function useAccessControlRoom(participant: RemoteParticipant) {
  const { dataTrack, setParticipantsRequestedAccess, participantsRequestedAccess } =
    useVideoContext();

  useEffect(() => {
    const trackMessageSubscribed = (data: string) => {
      switch (data) {
        case DataTrackMessage.REQUEST_ENTER_ROOM:
          dataTrack.send(DataTrackMessage.REQUEST_ENTER_ROOM_RECEIVED);
          setParticipantsRequestedAccess([...participantsRequestedAccess, participant.identity]);
          break;
        default:
          break;
      }
    };

    participant?.on("trackMessage", trackMessageSubscribed);

    return () => {
      participant.off("trackMessage", trackMessageSubscribed);
    };
  }, [participant]);
}
